import { BaseObject } from './BaseObject';

/*
 * Licensed under the TECNOPRO License, Version 1.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.tecnopro.net/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
export class TareaModel extends BaseObject {

    tareaId: number;
    tareaNombre: string;
    icon: string;
    routerLink: string;
    tareas: TareaModel[];

    asignable: boolean = true;

    puedeLeer: boolean;
    puedeCrear: boolean;
    puedeEscribir: boolean;
    puedeBorrar: boolean;
    puedeAprobar: boolean;
    
    puedeImportarArchivo: boolean;
    puedeAsignarResponsable: boolean;
    puedeCargarIncidencia: boolean;
}